<div class="badge-inner">
  <div *ngIf="count" class="badge-number">
    {{ count }}
  </div>
</div>
